export default __webpack_public_path__ + "assets/2cc3349b2bbd303e451cf4990c3d3a93.svg";